import type { IconProps } from './types';
import './icons.css';

export default function Edit({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-edit ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="m2.708 17.292 1.237-4.33a.83.83 0 0 1 .212-.36L13.38 3.38a2.292 2.292 0 0 1 3.24 3.24l-9.222 9.223c-.1.1-.224.173-.36.212l-4.33 1.237ZM12.13 4.63l3.24 3.24"
      />
    </svg>
  );
}
